import { render, staticRenderFns } from "./CropperWrapper.vue?vue&type=template&id=7f34ca72&scoped=true&"
import script from "./CropperWrapper.vue?vue&type=script&lang=js&"
export * from "./CropperWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CropperWrapper.vue?vue&type=style&index=0&id=7f34ca72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f34ca72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
